<template>
  <div class="infowrap">
      <div class="infotitle">推荐阅读</div>
      <div class="infolistbox">
        <a v-for="(item,index) in morerepeat" :href="item.detailURL">
          <div  class="infobox clearfix">
            <img :src="item.imageAddr" alt="">
            <div>
              <p class="title" v-text="item.title"></p>
              <p class="datetime">
                <span v-text="item.createTime"></span><img src="../../src/images/eye.png" alt=""><span v-text="item.readTotal"></span>
              </p>
            </div>
          </div>
        </a>
      </div>
  </div>
</template>

<script>
import '../js/flexible.debug.js'
import global from "../js/global.js"
export default {
  data () {
    return {
      morerepeat:[]
    }
  },
  props:["datatype","actionId","isshare","shareSwiper"],
  created(){
  },
  mounted(){
    
    this.init()
  },
  methods:{
     init(){
        this.$http.get("/content/unsecured/secondary/share/detail/bottom",{"params":{"dataType":this.datatype,"accountId":this.actionId}})
				.then((response) => {
          this.morerepeat = response.respData;
				});
     },
  }
}
</script>
<style lang="less" scoped>
  .infowrap{
    margin:30px 0 140px 0;
  }
  .infotitle{
    font-size:36px;
    line-height:80px;
    height:80px;
    margin-top:20px;
    padding-left:30px;
    padding-bottom:20px;
    border-bottom:0.03rem solid #EFEFEF;
  }
  .infolistbox{
    padding: 0 30px;
    .infobox{
      margin-top:52px;
      position: relative;
      p.title{
        font-size:32px;
        color: #333440;
      }
      p.datetime{
        margin-top:20px;
        position: absolute;
        bottom: 0;
        left: 0;
        margin-left:268px;
        span{
          margin-right: 28px;
          font-size:24px;
          color: #A4A4A4;
        }
        img{
          float: none;
          margin-right:6px;
          width: 28px;
          height: 22px;
        }
      }
      img{
        float: left;
        width: 240px;
        height: 168px;
        margin-right:28px;
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/morerepeat.vue